export const translations = {
  en: {
    applyNow: "Application Page",
    aboutPageTitle: "About - Defence Team Careers",
    applyPageTitle: "Apply - Defence Team Careers",
    contactPageTitle: "Report an Issue - Defence Team Careers",
    maintenancePageTitle: "Maintenance - Defence Team Careers",
    skipToMainContent: "Skip to main content",
    applicationSteps: "Application steps",
    relatedLinks: "Related links",
    governmentOfCanadaCorporate: "Government of Canada Corporate",
    termsAndConditionsUrl: "https://www.canada.ca/en/transparency/terms.html",
    privacyUrl: "https://www.canada.ca/en/transparency/privacy.html",
    governmentOfCanadaSymbolAlt: "Symbol of the Government of Canada",
    governmentOfCanadaAlt: "Government of Canada",
    languageSelection: "Language selection",
    languageToggleLabel: "Français",
    languageToggleAbbreviation: "FR",
    mainNavigationMenu: "Main navigation menu",
    applicantDetails: "Applicant details",
    priorityEntitlementUrl: "https://www.canada.ca/en/public-service-commission/services/information-priority-administration.html",
    opensInNewWindow: "opens in new window",
    jobApplication: "Goverment of Canada",
    step: "Step",
    of: "of",
    footerNav: "Press Enter or Click Next to Continue",
    next: "Next",
    previous: "Previous",
    resumedrop: "Drop your resume here",
    clicktobrowse: "or click to browse",
    supportsfiles: "Supports .PDF and .DOCX files",
    supportedfilesformats: "Supported file formats: .PDF and .DOCX",
    choosefile: "Choose File",
    nofilechosen: "No file chosen",
    skipandfill: "Skip & fill manually",
    startApplication: "Start Application",
    dismiss: "Dismiss",
    complete: "complete",
    tryagain: "Try Again",
    autoMove: "Resume information was extracted. Continue when you are ready.",
    filesErrorMessage: "Only .PDF and .DOCX files are accepted.",
    resumeFileError: "Invalid file or request. Please check your file and try again.",
    resumeUploadError: "Failed to upload resume. Please try again.",
    resumeParseError: "Failed to parse resume. Please try again.",
    resumeReceived: "Resume uploaded successfully",
    processingFailed: "Processing failed",
    processingFailed2: "Failed to process resume. Please try again.",
    AINotReady: "AI models are not ready. Please try again in a few minutes.",
    fileTooLarge: "File size too large. Please upload a file smaller than 10MB.",
    invalidResponse: "Invalid response format",
    parseDataNotFound: "Parsed data not found. Please try uploading your resume again.",
    parseDataNotRetrieved: "Failed to retrieve parsed data. Please try again.",
    failedMLStatus: "Failed to get ML status.",
    failedMissingInfoFeilds: "Failed to retrieve missing fields information.",
    failedToCompleteFeilds: "Failed to complete mandatory fields.",
    resumeParseTimeOut: "Resume parsing timed out. Please try again.",
    autoExtract: "We’ve automatically extracted information from your resume",
    continueReview: "Next: Review information",
    invalidFile: "Invalid File",
    resumeProcessing: "Processing resume...",
    uploading: "Uploading file...",
    extracting: "Extracting information...",
    processing: "Processing document...",
    processed: "Resume processed successfully!",
    resumeUploadHeader: "Upload Your Resume",
    resumeUploadDesc: "Let's start by uploading your resume. We'll automatically extract information to make the process faster.",
    contactInfoHeader: "Applicant Contact Info and Employment Status",
    contactInfoSubheader: "Complete your basic contact information. Fields marked with * are mandatory.",
    contactSectionTitle: "Contact Information",
    firstNameLabel: "First Name",
    firstNamePlaceholder: "Enter your first name",
    lastNameLabel: "Last Name",
    lastNamePlaceholder: "Enter your last name",
    emailLabel: "What is your preferred email address?",
    emailPlaceholder: "your.email@example.com",
    citizenshipLabel: "What is your citizenship?",
    citizenshipPlaceholder: "Select your citizenship status",
    citizenshipCanadian: "Canadian Citizen",
    citizenshipPR: "Permanent Resident",
    citizenshipWorkPermit: "Work Permit",
    citizenshipOther: "Other",
    currentLocationLabel: "Current Location (City, Province/Territory, Country)",
    currentLocationPlaceholder: "e.g., Ottawa, Ontario, Canada",
    formValidationSummaryTitle: "Your form contains errors",
    formValidationSummaryBody: "Please correct the following fields and submit again.",
    formValidationRequiredMessage: "This field is required.",
    formValidationEmailMessage: "Please enter a valid email address.",
    formValidationUrlMessage: "Links are not allowed. Please remove any URLs.",
    extractedFromResume: "Extracted from resume",
    previousButton: "Previous",
    nextButton: "Next: Priorities & Entitlements",
    nextEducationButton: "Next: Security & Education",
    prioritiesHeader: "Priorities and Entitlements",
    prioritiesSubheader: "Information about your priority entitlement status. Fields marked with * are mandatory.",
    prioritiesSectionTitle: "Priority Entitlement Information",
    prioritiesLabel: "Do you have a Priority Entitlement status?",
    prioritiesLearnMore: "Learn more about",
    prioritiesLearnMoreLink: "Priority Entitlement status",
    prioritiesYes: "Yes",
    prioritiesNo: "No",
    prioritiesExtracted: "Extracted from resume",
    prioritiesInfoBoxTitle: "About Priority Entitlement",
    prioritiesInfoBoxText: "This includes priorities for surplus employees, laid-off employees, and medically released members of the Canadian Armed Forces.",
    nextEmploymentButton: "Next: Employment Status",
    employmentHeader: "Employment Status",
    employmentSubheader: "Information about your current employment status. Fields marked with * are mandatory.",
    employmentSectionTitle: "Federal Public Service Employment",
    currentlyEmployedFPSLabel: "Are you currently employed by the Federal Public Service?",
    currentlyEmployedFPSYes: "Yes",
    currentlyEmployedFPSNo: "No",
    currentClassificationLabel: "What is your current classification?",
    currentClassificationPlaceholder: "Select your current classification",
    currentClassificationHelp: "Select your current federal job classification from the official list",
    typeOfEmploymentLabel: "What is your current type of employment?",
    typeOfEmploymentPlaceholder: "Select your employment type",
    typeOfEmploymentTerm: "Term",
    typeOfEmploymentIndeterminate: "Indeterminate",
    typeOfEmploymentStudent: "Student",
    typeOfEmploymentCasual: "Casual",
    typeOfEmploymentPartTime: "Part-Time Worker",
    employmentEndDateLabel: "What is your employment's end date?",
    employmentEndDateHelp: "For indeterminate positions, you can enter a future date or leave blank",
    priNumberLabel: "Do you have a Personal Record Identifier (PRI) Number?",
    priNumberYes: "Yes",
    priNumberNo: "No",
    priNumberMaybe: "Maybe",
    employmentInfoBoxTitle: "About Federal Public Service Employment",
    employmentInfoBoxText: "The Federal Public Service includes all departments, agencies, and Crown corporations of the Government of Canada. Your current employment status helps us understand your eligibility for different types of positions.",
    nextLanguageButton: "Next: Language & SLE Information",
    languageSLEHeader: "Language & Second Language Evaluation (SLE)",
    languageSLESubheader: "Information about your language abilities and other qualifications. Fields marked with * are mandatory.",
    languageSectionTitle: "Language Requirements",
    firstOfficialLanguageLabel: "What is your first official language?",
    firstOfficialLanguageLearnMore: "Learn more about",
    firstOfficialLanguageLearnMoreLink: "language requirements for candidates",
    firstOfficialLanguageEnglish: "English",
    firstOfficialLanguageFrench: "French",
    firstOfficialLanguageOther: "Other",
    validSLELabel: "Do you have valid SLE results? If yes, select the tests in which you have valid results.",
    validSLELearnMore: "Learn more about",
    validSLELearnMoreLink: "Second Language Testing",
    validSLEReading: "Reading",
    validSLEWriting: "Writing",
    validSLEOral: "Oral",
    validSLENo: "No valid SLE results",
    sleLevelLabel: "What SLE level are you?",
    sleLevelPlaceholder: "e.g., BBB, CCC, EEE",
    sleLevelHelp: "Enter your SLE level (e.g., BBB, CCC, EEE)",
    sleExpiryDateLabel: "When do your SLE results expire?",
    languageProfilesLabel: "What language profiles are you interested in being considered for?",
    languageProfileEnglish: "English Essential Positions",
    languageProfileFrench: "French Essential Positions",
    languageProfileBilingual: "Bilingual Positions",
    securityEducationSectionTitle: "Security & Education",
    validSecurityClearanceLabel: "Do you have a valid Security Clearance?",
    validSecurityClearancePlaceholder: "Select your security clearance level",
    validSecurityClearanceReliability: "Reliability Status",
    validSecurityClearanceEnhanced: "Enhanced Reliability",
    validSecurityClearanceSecret: "Secret Clearance",
    validSecurityClearanceOther: "Other",
    validSecurityClearanceNo: "No",
    highestEducationLevelLabel: "What is your highest level of education?",
    highestEducationSubLabel: "If you are currently attending a post-secondary institution, please select 'Post-Secondary Education'.",
    highestEducationLevelPlaceholder: "Select your highest education level",
    highestEducationLevelLessThanHS: "Less than High School graduation",
    highestEducationLevelSecondary: "Secondary School Diploma",
    highestEducationLevelSomePostSecondary: "Some Post-Secondary Education",
    highestEducationLevelPostSecondary: "Post-Secondary Education",
    postSecondaryEducationLevelLabel: "What is your level of post-secondary education?",
    postSecondaryEducationLevelPlaceholder: "Select post-secondary education level",
    postSecondaryEducationLevelBachelors: "Bachelor's Degree",
    postSecondaryEducationLevelAttestation: "College / Cégep Attestation",
    postSecondaryEducationLevelCertificate: "College / Cégep Certificate / Diploma",
    postSecondaryEducationLevelAppliedBachelor: "College / Cégep Applied Bachelor",
    postSecondaryEducationLevelUniversityCredits: "University Credits / Certificate / Diploma",
    postSecondaryEducationLevelMasters: "Master's Degree",
    postSecondaryEducationLevelMD: "Doctor of Medicine",
    postSecondaryEducationLevelPhD: "Doctor of Philosophy (PhD)",
    postSecondaryEducationLevelDESS: "Graduate Diploma (DESS)",
    postSecondaryInstitutionLabel: "What is the name of the post-secondary institution?",
    postSecondaryInstitutionPlaceholder: "e.g., University of Ottawa, Algonquin College",
    areaOfStudyLabel: "What was your area of study?",
    areaOfStudyPlaceholder: "e.g., Computer Science, Information Technology",
    graduationDateLabel: "What is your graduation date (past or expected)?",
    lookingForITRoleLabel: "Are you looking for a role in the Information Technology (IT) Field?",
    lookingForITRoleYes: "Yes",
    lookingForITRoleOther: "Other",
    nextITCompetenciesButton: "Next: IT Skills & Competencies",
    itCompetenciesHeader: "IT Skills & Competencies",
    itCompetenciesSubheader: "Technical skills and experience assessment.",
    q27: "What programming languages do you have experience with?",
    q27other: "Please Specify",
    q28: "What frameworks and libraries do you have experience with?",
    q28other: "Please Specify",
    q29: "What cloud operations and tools do you have experience with?",
    q29other: "Please Specify",
    q30: "What data & analytics tools do you have experience with?",
    q30other: "Please Specify",
    q31: "What AI/ML, data science, and cloud ML tools do you have experience with?",
    q31other: "Please Specify",
    q32: "What cybersecurity areas and tools do you have experience with?",
    q32other: "Please Specify",
    q33: "What DevOps tools do you have experience with?",
    q33other: "Please Specify",
    q34: "What version control tools do you have experience with?",
    q34other: "Please Specify",
    q35: "What enterprise tools & platforms do you have experience with?",
    q35other: "Please Specify",
    q36: "What project & collaboration tools do you have experience with?",
    q36other: "Please Specify",
    q37: "What project management methodologies do you have experience with?",
    q37other: "Please Specify",
    resumeInfoHeader: "Resume Information",
    q38: "Do you have any additional skills, tools, or methodologies not mentioned above that are relevant to this position?",
    q38Placeholder: "Please describe any additional relevant skills...",
    q39: "What is your greatest professional achievement to date, and how did it impact your organization or team?",
    q39Placeholder: "Please describe your greatest professional achievement...",
    q40: "Is there anything else you would like us to know about your background, experience, or qualifications?",
    additionalInfoDesc: "Please do not include any links in your response.",
    q40Placeholder: "Any additional information you'd like to share...",
    notSpecified: "Not specified",
    applicationSummaryHeader: "Application Summary",
    applicationSummarySubheader: "Please review all information before submitting your application.",
    priorityEntitlementsHeader: "Priority Entitlements",
    positionTitleLabel: "Position Title:",
    departmentLabel: "Department:",
    missingRequiredInfo: "Missing Required Information",
    submissionError: "Submission Error",
    submissionErrorMessage: "Failed to submit application. Please try again. If still having issues contact: myfuture-monfutur@forces.gc.ca",
    networkErrorMessage: "Network error. Please check your connection and try again.",
    pleaseProvide: "Please provide:",
    submittingApplication: "Submitting Application...",
    submitApplicationButton: "Submit Application",
    applicationSubmittedHeader: "Application Submitted Successfully!",
    applicationSubmittedMessage: "Thank you, {firstName}, for submitting your application. You will reveive a confirmation email and your application will be reviewed as part of our selection process.",
    applicationReferenceHeader: "Application Reference",
    applicationIdLabel: "Application ID:",
    applicationSubmittedLabel: "Submitted:",
    contactHRMessage: "Have questions about your application?",
    contactHRButton: "Contact HR",
    backToHomeButton: "Back to Home",
    attached: "Attached",
    currentLocationEnd: "Current Location",
    sum1header: "Contact Information & Employment Status",
    sum2header: "Priorities and Entitlements",
    sum3header: "Employment Status",
    sum4header: "Language & SLE",
    sum5header: "IT Competencies and Extra Information",
    applicationsubmittedtitle: "Thank you for your application! We will be in touch soon",
    consentHeader: "Privacy Notice",
    consentSubHeader: "The Department of National Defence (DND) is preparing to grow and adapt as the international landscape becomes more complex. DND's Digital Services Group (DSG) is increasing recruitment efforts to ensure DND has the talent needed to fulfill its mission.",
    notice: "Notice",
    consent1: "After your application is submitted, your resume will be stored in the DND resume repository for up to one year for recruitment purposes.",
    consent2: "Any false and/or fraudulent information may result in:",
    consent2a: "the rejection of your application;",
    consent2b: "not hiring you;",
    consent2c: "the revocation of your job in the public service if you have already been hired;",
    consent2d: "the Public Service Commission (PSC) taking any corrective action it considers appropriate; and in the case of fraud, in addition to the above consequences, you may also be subject to a criminal investigation and found guilty of a criminal offence;",
    consent2e: "if it is suspected that an error, omission, or improper conduct occurred, the information you provide could be used for the purpose of an investigation by the PSC or by a Deputy Head under the authority of the Public Service Employment Act (PSEA).",
    consentBabble: "If there is reason to believe that fraud may have occured in an appointment process, the PSC may decide to investigate pursuant to section 69 of the PSEA. A person who commits fraud may also be subject to a criminal investigation and found guilty of a criminal offence under the section 133 of the PSEA. The PSC also has the authority to conduct audits pursuant to section 17 of the PSEA.",
    consentConfirmation: "I confirm I have read and understood the contents of this Notice, and consent to my resume being stored in the DND repository for up to one year",
    nextAiConsent: "Next: AI consent",
    nextResumeUpload: "Next: Start application",
    prorityEnd: "Priority Entitlement status",
    typeofEmployment: "Type of Employment",
    employmentEndDate: "Employment End Date",
    priNumber: "PRI Number",
    Institution: "Institution",
    areaOfStudy: "Area of Study",
    graduationDate: "Graduation Date",
    lookingForITRole: "Looking for an IT Role?",
    other: "Other",
    additionalInfoHeader: "Additional Information Questions",
    attachedResume: "Attached Resume",
    aiConsentHeader: "Artificial Intelligence (AI) Assistance",
    aiConsentSubHeader: "Confirm if you'd like artificial intelligence (AI) to assist you with drafting your application.",
    aiConsentLabel: "About AI Assistance",
    aiConsentblab: "We offer an optional AI tool that can help you draft parts of your application (for example, automatically filling in fields based on your resume). This tool is only used if you choose to opt in.",
    aiConsentul1: "• The AI tool is not used to review, evaluate, or make decisions about your application.",
    aiConsentul2: "• Once your application is submitted, the AI tool is no longer used in any part of the hiring process.",
    aiConsentYes: "Yes, I would like to use AI assistance.",
    aiConsentNo: "No, I want to complete my application without AI assistance.",
    validSLEResults: "Valid SLE Results",
    currentLevel: "What is your current classification level?",
    defenceTeamCareersSupport: "Defence Team Careers Support",
    reportAnIssue: "Report an Issue",
    aboutUs: "About us",
    termsOfUseJobSeekers: "Terms of use - Job seekers",
    termsOfUseEmployers: "Terms of use - Employers",
    termsAndConditions: "Terms and conditions",
    privacy: "Privacy",
    defenceTeamCareers: "Defence IT Community Management Office",
    statusAIConsent: "Artificial Intelligence (AI) Consent",
    statusResumeUploaded: "Resume Upload",
    statusContactInformation: "Contact Information",
    statusPriorities: "Priority Entitlement",
    statusEmployment: "Employment Status",
    statusLanguageInformation: "Language Information",
    statusSecurityEducation: "Security & Education",
    statusSkillsCompetencies: "Skills & Competencies",
    statusReview: "Review",
    employmentDescription: "The Federal Public Service includes all departments, agencies, and Crown corporations of the Government of Canada. Your current employment status helps us understand your eligibility for different types of positions.",
    PRIDescription: "A PRI is a number assigned to associate an employee with their personal records in the federal public service.",
    employmentDate: "If you hold an indeterminate position, leave this field blank.",
    required: "(required)",
    stepHeader: "Defence Team Careers",
    aboutUsDescParagraph1: "build partnerships with academic and industry stakeholders",
    aboutUsDescParagraph2: "aligns IT staffing with departmental priorities",
    contactUs: "Contact Us",
    contactUsDescription: "Have questions or need assistance with your application? Our team is here to help. Please reach out to us using the contact information below.",
    contactEmail: "Email",
    reportIssueDescription: "If you encounter an issue while submitting your information, please contact us.",
    supportDescription: "The Careers Support section provides guidance and contact information for HR-related inquiries, recruitment processes, and employment resources within the Defence Team.",
    reportIncluds: "When reporting a problem, include:",
    reportStep1: "- A brief description of the issue",
    reportStep2: "- The step where the issue occurred",
    reportStep3: "- Any error message displayed (if applicable)",
    reportStep4: "- The date and time when the issue occurred",
    reportReason: "Providing this information will help us respond more effectively.",
    supportContactPrefix: "Please contact us at",
    supportContactSuffix: "and a member of our team will get back to you as soon as possible.",
    confirmation: "Confirmation",
    pleaseIndicatePreference: "Please indicate your preference.",
    consentNo: "I do not consent",
    maintenanceNoticeTitle: "Scheduled Maintenance Notice",
    maintenanceNoticeMessage: "Our system is currently down for maintenance from {startDate} to {endDate}.",
    maintenanceApology: "We apologize for this inconvenience and appreciate your patience.",
    maintenanceStartDate: "Friday, November 21st, 2:00 PM (EST)",
    maintenanceEndDate: "Monday, November 24th, 8:00 AM (EST)",
    dateModifiedLabel: "Date modified:",
    yourProgress: "Your Progress",
    currentStep: "Current step",
    error: "Error",
    qualifiedFullyAssessedPoolLabel: "Are you qualified in a fully assessed pool?",
    qualifiedFullyAssessedPoolYes: "Yes",
    qualifiedFullyAssessedPoolNo: "No",
    staffingProcessLabel: "If yes, please provide the selection process number",
    staffingProcessPlaceholder: "Please enter your answer here",
    staffingProcess: "Selection Process",
    GroupFullyAssessedLabel: "Please identify the Group you are fully assessed in:",
    GroupFullyAssessedPlaceholder: "Select the Group you are fully assessed in",
    LevelFullyAssessedLabel: "Please identify the Level you are fully assessed in:",
    GroupFullyAssessed: "current classification for fully assessed pool",
    LevelFullyAssessed: "current classification level for fully assessed pool",
    areaofStudyEnd: "Field of Specialization",
    postSecondaryInstitutionEnd: "Post-secondary educational institution",
    postSecondaryEducationLevelEnd: "Level of post-secondary education",
    graduationDateEnd: "Graduation date",
    lookingForITRoleEnd: "Looking for an IT position?",
  },
  fr: {
    applyNow: "Page de candidature",
    aboutPageTitle: "À propos de nous - Carrières de l'Équipe de la Défense",
    applyPageTitle: "Postuler - Carrières de l'Équipe de la Défense",
    contactPageTitle: "Signaler un problème - Carrières de l'Équipe de la Défense",
    maintenancePageTitle: "Maintenance - Carrières de l'Équipe de la Défense",
    skipToMainContent: "Passer au contenu principal",
    applicationSteps: "Étapes de la demande",
    relatedLinks: "Liens connexes",
    governmentOfCanadaCorporate: "Organisation du gouvernement du Canada",
    termsAndConditionsUrl: "https://www.canada.ca/fr/transparence/avis.html",
    privacyUrl: "https://www.canada.ca/fr/transparence/confidentialite.html",
    governmentOfCanadaSymbolAlt: "Symbole du gouvernement du Canada",
    governmentOfCanadaAlt: "Gouvernement du Canada",
    languageSelection: "Sélection de la langue",
    languageToggleLabel: "English",
    languageToggleAbbreviation: "EN",
    mainNavigationMenu: "Menu de navigation principal",
    applicantDetails: "Renseignements sur la personne candidate",
    priorityEntitlementUrl: "https://www.canada.ca/fr/commission-fonction-publique/services/administration-priorites.html",
    opensInNewWindow: "ouvre dans une nouvelle fenêtre",
    jobApplication: "Gouvernement du Canada",
    step: "Étape",
    of: "de",
    footerNav: "Appuyez sur Retour ou cliquez sur Suivant pour continuer",
    next: "Suivant",
    previous: "Précédent",
    resumedrop: "Téléverser votre CV ici",
    clicktobrowse: "ou cliquez ici pour parcourir vos documents",
    supportsfiles: "Prend en charge les fichiers .PDF et .DOCX",
    supportedfilesformats: "Formats de fichiers pris en charge : .PDF et .DOCX",
    choosefile: "Choisir un fichier",
    nofilechosen: "Aucun fichier choisi",
    skipandfill: "Sauter et remplir manuellement",
    startApplication: "Démarrer l'application",
    dismiss: "Ignorer",
    complete: "complet",
    tryagain: "Essayez encore",
    autoMove: "Les renseignements du CV ont été extraits. Continuez lorsque vous êtes prêt.",
    filesErrorMessage: "Seuls les fichiers .PDF et .DOCX sont acceptés.",
    resumeFileError: "Fichier ou requête invalide. Veuillez vérifier votre fichier et réessayer.",
    resumeUploadError: "Impossible de télécharger le CV. Veuillez réessayer.",
    resumeParseError: "Impossible d'analyser le CV. Veuillez réessayer.",
    resumeReceived: "Votre CV a été bien reçu!",
    processingFailed: "Échec du traitement",
    processingFailed2: "Impossible de traiter votre CV. Veuillez réessayer.",
    AINotReady: "Les modèles d'IA ne sont pas prêts. Veuillez réessayer dans quelques minutes.",
    fileTooLarge: "Le fichier est trop volumineux. Veuillez en télécharger un de moins de 10 Mo.",
    invalidResponse: "Format de réponse invalide",
    parseDataNotFound: "Données analysées introuvables. Veuillez réessayer de télécharger votre CV.",
    parseDataNotRetrieved: "Impossible de récupérer les données analysées. Veuillez réessayer.",
    failedMLStatus: "Impossible d'obtenir le statut ML.",
    failedMissingInfoFeilds: "Impossible de récupérer les informations des champs manquants.",
    failedToCompleteFeilds: "Champs obligatoires non remplis.",
    resumeParseTimeOut: "L'analyse a expiré. Veuillez réessayer.",
    autoExtract: "Nous avons automatiquement extrait des renseignements de votre CV.",
    continueReview: "Suivant : Vérifier les renseignements",
    invalidFile: "Fichier non accepté",
    resumeProcessing: "Reprise du traitement...",
    uploading: "Téléchargement du fichier...",
    extracting: "En cours d'extraire l'information...",
    processing: "Traitement du fichier...",
    processed: "Traitement du CV réussi",
    resumeUploadHeader: "Téléverser votre CV",
    resumeUploadDesc: "Commencez par téléverser votre CV. Nous allons extraire l'information automatiquement",
    contactInfoHeader: "Coordonnées du candidat et statut d'emploi",
    contactInfoSubheader: "Complétez vos informations de contact de base. Les champs marqués d'un * sont obligatoires.",
    contactSectionTitle: "Informations de contact",
    firstNameLabel: "Prénom",
    firstNamePlaceholder: "Entrez votre prénom",
    lastNameLabel: "Nom de famille",
    lastNamePlaceholder: "Entrez votre nom de famille",
    emailLabel: "Quelle est votre adresse courriel préférée?",
    emailPlaceholder: "votre.courriel@exemple.com",
    citizenshipLabel: "Quelle est votre citoyenneté?",
    citizenshipPlaceholder: "Sélectionnez votre statut de citoyenneté",
    citizenshipCanadian: "Citoyen canadien",
    citizenshipPR: "Résident permanent",
    citizenshipWorkPermit: "Permis de travail",
    citizenshipOther: "Autre",
    currentLocationLabel: "Lieu actuel (ville, province ou territoire, pays)",
    currentLocationPlaceholder: "p. ex. : Ottawa, Ontario, Canada",
    formValidationSummaryTitle: "Le formulaire contient des erreurs",
    formValidationSummaryBody: "Veuillez corriger les champs suivants et soumettre de nouveau.",
    formValidationRequiredMessage: "Ce champ est obligatoire.",
    formValidationEmailMessage: "Veuillez saisir une adresse courriel valide.",
    formValidationUrlMessage: "Les liens ne sont pas autorisés. Veuillez supprimer toute URL.",
    extractedFromResume: "Extrait du CV",
    previousButton: "Précédent",
    nextButton: "Suivant : Priorités et droits",
    nextEducationButton: "Suivant : Sécurité et éducation",
    prioritiesHeader: "Priorités et droits",
    prioritiesSubheader: "Informations sur votre statut de priorité. Les champs marqués d'un * sont obligatoires.",
    prioritiesSectionTitle: "Informations sur le droit de priorité",
    prioritiesLabel: "Bénéficiez-vous d’un droit de priorité?",
    prioritiesLearnMore: "En savoir plus sur",
    prioritiesLearnMoreLink: "le droit de priorité",
    prioritiesYes: "Oui",
    prioritiesNo: "Non",
    prioritiesExtracted: "Extrait du CV",
    prioritiesInfoBoxTitle: "À propos du droit de priorité",
    prioritiesInfoBoxText: "Cela comprend notamment les droits de priorité des fonctionnaires excédentaires, des personnes mises en disponibilité et des membres des Forces armées canadiennes libérés pour des raisons médicales.",
    nextEmploymentButton: "Suivant : Statut d'emploi",
    employmentHeader: "Statut d'emploi",
    employmentSubheader: "Informations sur votre statut d'emploi actuel. Les champs marqués d'un * sont obligatoires.",
    employmentSectionTitle: "Emploi dans la fonction publique fédérale",
    currentlyEmployedFPSLabel: "Êtes-vous actuellement employé par la fonction publique fédérale?",
    currentlyEmployedFPSYes: "Oui",
    currentlyEmployedFPSNo: "Non",
    currentClassificationLabel: "Quelle est votre classification actuelle?",
    currentClassificationPlaceholder: "Sélectionnez votre classification actuelle",
    currentClassificationHelp: "Sélectionnez votre classification d'emploi fédéral actuelle dans la liste officielle",
    typeOfEmploymentLabel: "Quel est votre type d'emploi actuel?",
    typeOfEmploymentPlaceholder: "Sélectionnez votre type d'emploi",
    typeOfEmploymentTerm: "Durée déterminée",
    typeOfEmploymentIndeterminate: "Durée indéterminée",
    typeOfEmploymentStudent: "Étudiant",
    typeOfEmploymentCasual: "Occasionnel",
    typeOfEmploymentPartTime: "Travailleur à temps partiel",
    employmentEndDateLabel: "Quelle est la date de fin de votre emploi?",
    employmentEndDateHelp: "Pour les postes indéterminés, vous pouvez laisser vide",
    priNumberLabel: "Avez-vous un code d’identification de dossier personnel (CIDP)?",
    priNumberYes: "Oui",
    priNumberNo: "Non",
    priNumberMaybe: "Peut-être",
    employmentInfoBoxTitle: "À propos de l'emploi dans la fonction publique fédérale",
    employmentInfoBoxText: "La fonction publique fédérale comprend tous les ministères, organismes et sociétés d'État du gouvernement du Canada. Votre statut d'emploi actuel nous aide à comprendre votre admissibilité à différents types de postes.",
    nextLanguageButton: "Suivant : Renseignements sur la langue et l’ELS",
    languageSLEHeader: "Langue et évaluation de la langue seconde (ELS)",
    languageSLESubheader: "Informations sur vos compétences linguistiques et autres qualifications. Les champs marqués d'un * sont obligatoires.",
    languageSectionTitle: "Exigences linguistiques",
    firstOfficialLanguageLabel: "Quelle est votre première langue officielle?",
    firstOfficialLanguageLearnMore: "En savoir plus sur",
    firstOfficialLanguageLearnMoreLink: "les exigences linguistiques pour les candidats",
    firstOfficialLanguageEnglish: "Anglais",
    firstOfficialLanguageFrench: "Français",
    firstOfficialLanguageOther: "Autre",
    validSLELabel: "Avez-vous des résultats valides à l’évaluation de langue seconde (ELS)? Si oui, sélectionnez les tests pour lesquels vous avez des résultats valides.",
    validSLELearnMore: "En savoir plus sur",
    validSLELearnMoreLink: "l'évaluation de la langue seconde",
    validSLEReading: "Compréhension de l’écrit",
    validSLEWriting: "Expression écrite",
    validSLEOral: "Oral",
    validSLENo: "Aucun résultat valide à l’ELS",
    sleLevelLabel: "Quel est votre niveau ELS?",
    sleLevelPlaceholder: "ex. BBB, CCC, EEE",
    sleLevelHelp: "Indiquez votre niveau ELS (ex. BBB, CCC, EEE)",
    sleExpiryDateLabel: "Quand vos résultats ELS expirent-ils?",
    languageProfilesLabel: "Pour quels profils linguistiques souhaitez-vous que votre candidature soit prise en considération?",
    languageProfileEnglish: "Postes à anglais essentiel",
    languageProfileFrench: "Postes à français essentiel",
    languageProfileBilingual: "Postes bilingues",
    securityEducationSectionTitle: "Sécurité et éducation",
    validSecurityClearanceLabel: "Avez-vous une habilitation de sécurité valide?",
    validSecurityClearancePlaceholder: "Sélectionnez votre niveau de sécurité",
    validSecurityClearanceReliability: "Cote de fiabilité",
    validSecurityClearanceEnhanced: "Fiabilité renforcée",
    validSecurityClearanceSecret: "Cote de sécurité secrète",
    validSecurityClearanceOther: "Autre",
    validSecurityClearanceNo: "Non",
    highestEducationLevelLabel: "Quel est votre niveau d’études le plus élevé?",
    highestEducationSubLabel: "Si vous fréquentez actuellement un établissement postsecondaire, veuillez sélectionner 'Études postsecondaires'.",
    highestEducationLevelPlaceholder: "Sélectionnez votre niveau d’études le plus élevé",
    highestEducationLevelLessThanHS: "Études secondaires non terminées",
    highestEducationLevelSecondary: "Diplôme d'études secondaires",
    highestEducationLevelSomePostSecondary: "Quelques études postsecondaires",
    highestEducationLevelPostSecondary: "Études postsecondaires",
    postSecondaryEducationLevelLabel: "Quel est votre niveau d’études postsecondaires?",
    postSecondaryEducationLevelPlaceholder: "Sélectionnez le niveau d'études postsecondaires",
    postSecondaryEducationLevelBachelors: "Baccalauréat",
    postSecondaryEducationLevelAttestation: "Attestation d’un collège ou d’un cégep",
    postSecondaryEducationLevelCertificate: "Certificat ou diplôme d’un collège ou d’un cégep",
    postSecondaryEducationLevelAppliedBachelor: "Baccalauréat appliqué d’un collège ou d’un cégep",
    postSecondaryEducationLevelUniversityCredits: "Crédits, certificat ou diplôme universitaires",
    postSecondaryEducationLevelMasters: "Maîtrise",
    postSecondaryEducationLevelMD: "Doctorat en médecine",
    postSecondaryEducationLevelPhD: "Doctorat (Ph. D.)",
    postSecondaryEducationLevelDESS: "Diplôme d'études supérieures spécialisées (DESS)",
    postSecondaryInstitutionLabel: "Quel est le nom de l'établissement postsecondaire?",
    postSecondaryInstitutionPlaceholder: "ex. Université d'Ottawa, Collège Algonquin",
    areaOfStudyLabel: "Quel était votre domaine d’études?",
    areaOfStudyPlaceholder: "ex. Informatique, Technologies de l'information",
    graduationDateLabel: "Quelle est votre date d'obtention du diplôme (passée ou prévue) ?",
    lookingForITRoleLabel: "Cherchez-vous un poste dans le domaine des technologies de l'information (TI)?",
    lookingForITRoleYes: "Oui",
    lookingForITRoleOther: "Autre",
    nextITCompetenciesButton: "Suivant : Compétences et habiletés TI",
    itCompetenciesHeader: "Compétences et habiletés TI",
    itCompetenciesSubheader: "Évaluation des compétences techniques et de l'expérience",
    q27: "Avec quels langages de programmation avez-vous de l'expérience?",
    q27other: "Veuillez préciser",
    q28: "Avec quels cadriciels et bibliothèques avez-vous de l’expérience?",
    q28other: "Veuillez préciser",
    q29: "Avec quelles opérations infonuagiques et quels outils infonuagiques avez-vous de l’expérience?",
    q29other: "Veuillez préciser",
    q30: "Avec quels outils de données et d'analytique avez-vous de l'expérience?",
    q30other: "Veuillez préciser",
    q31: "Avec quels outils d'IA/ML, de science des données et de ML cloud avez-vous de l'expérience?",
    q31other: "Veuillez préciser",
    q32: "Avec quels domaines et outils de cybersécurité avez-vous de l'expérience?",
    q32other: "Veuillez préciser",
    q33: "Avec quels outils DevOps avez-vous de l'expérience?",
    q33other: "Veuillez préciser",
    q34: "Avec quels outils de gestion de versions avez-vous de l'expérience?",
    q34other: "Veuillez préciser",
    q35: "Avec quels outils et plateformes d'entreprise avez-vous de l'expérience?",
    q35other: "Veuillez préciser",
    q36: "Avec quels outils de projet et de collaboration avez-vous de l'expérience?",
    q36other: "Veuillez préciser",
    q37: "Avec quelles méthodologies de gestion de projet avez-vous de l'expérience?",
    q37other: "Veuillez préciser",
    resumeInfoHeader: "Informations supplémentaire",
    q38: "Avez-vous des compétences, outils ou méthodologies supplémentaires pertinents pour ce poste qui n'ont pas été mentionnés ci-dessus?",
    q38Placeholder: "Veuillez décrire toute compétence supplémentaire pertinente...",
    q39: "Quelle est votre plus grande réalisation professionnelle à ce jour et comment a-t-elle eu un impact sur votre organisation ou équipe?",
    q39Placeholder: "Décrivez votre plus grande réalisation professionnelle...",
    q40: "Y a-t-il autre chose que vous souhaitez que nous sachions sur votre parcours, votre expérience ou vos qualifications?",
    additionalInfoDesc: "Veuillez ne pas inclure de liens dans votre réponse.",
    q40Placeholder: "Toute information supplémentaire que vous souhaitez partager...",
    notSpecified: "Non spécifié",
    applicationSummaryHeader: "Résumé de la demande",
    applicationSummarySubheader: "Veuillez vérifier toutes les informations avant de soumettre votre demande.",
    priorityEntitlementsHeader: "Droits de priorité",
    positionTitleLabel: "Intitulé du poste :",
    departmentLabel: "Ministère :",
    missingRequiredInfo: "Informations requises manquantes",
    submissionError: "Erreur de soumission",
    submissionErrorMessage: "Échec de la soumission de la demande. Veuillez réessayer. Si vous rencontrez toujours des problèmes, contactez : myfuture-monfutur@forces.gc.ca",
    networkErrorMessage: "Erreur de réseau. Veuillez vérifier votre connexion et réessayer.",
    pleaseProvide: "Veuillez fournir :",
    submittingApplication: "Soumission de la demande...",
    submitApplicationButton: "Soumettre la demande",
    applicationSubmittedHeader: "Demande soumise avec succès!",
    applicationSubmittedMessage: "Merci {firstName} d'avoir soumis votre candidature. Vous recevrez un courriel de confirmation et votre candidature sera examinée dans le cadre de notre processus de sélection.",
    applicationReferenceHeader: "Référence de la demande",
    applicationIdLabel: "Numéro de la demande :",
    applicationSubmittedLabel: "Soumis :",
    contactHRMessage: "Des questions concernant votre demande?",
    contactHRButton: "Contacter RH",
    backToHomeButton: "Retour à l'accueil",
    attached: "Ficher joint",
    currentLocationEnd: "Localisation actuelle",
    sum1header: "Coordonnées et statut d'emploi",
    sum2header: "Priorités et droits",
    sum3header: "Statut d'emploi",
    sum4header: "Langue et ELS",
    sum5header: "Compétences TI et informations supplémentaires",
    applicationsubmittedtitle: "Merci pour votre demande! Nous serons en contacte sous peu",
    consentHeader: "Avis de confidentialité",
    consentSubHeader: "Le ministère de la Défense nationale (MDN) se prépare à accroître et à s’adapter dans un contexte international de plus en plus complexe. Le Groupe des services numériques (GSN) du MDN intensifie ses efforts de recrutement afin de s’assurer que le MDN dispose des talents nécessaires pour accomplir sa mission.",
    notice: "Avis",
    consent1: "Une fois votre candidature soumise, votre CV sera conservé dans le répertoire de CV du MDN pendant une durée maximale d'un an à des fins de recrutement.",
    consent2: "Tout renseignement faux ou frauduleux peut entraîner :",
    consent2a: "le rejet de votre candidature ;",
    consent2b: "ne pas procéder à votre embauche ;",
    consent2c: "la révocation de votre emploi dans la fonction publique si vous avez déjà été embauché(e) ;",
    consent2d: "la prise de toute mesure corrective jugée appropriée par la Commission de la fonction publique (CFP) ; et, en cas de fraude, en plus des conséquences mentionnées ci-dessus, vous pourriez également faire l'objet d'une enquête criminelle et être reconnu(e) coupable d'une infraction criminelle ;",
    consent2e: "Si l’on soupçonne qu’une erreur, une omission ou une conduite inappropriée s’est produite, les renseignements que vous fournissez pourraient être utilisés aux fins d’une enquête menée par la CFP ou par un administrateur général en vertu de la Loi sur l’emploi dans la fonction publique (LEFP).",
    consentBabble: "S'il existe des raisons de croire qu'une fraude a pu se produire dans un processus de nomination, la CFP peut décider d'enquêter conformément à l'article 69 de la LEFP. Une personne qui commet une fraude peut également faire l'objet d'une enquête criminelle et être reconnue coupable d'une infraction criminelle en vertu de l'article 133 de la LEFP. La CFP a également le pouvoir de mener des audits conformément à l'article 17 de la LEFP.",
    consentConfirmation: "Je confirme avoir lu et compris le contenu de cet avis, et je consens à ce que mon CV soit conservé dans le répertoire du MDN pendant une durée maximale d’un an.",
    nextAiConsent: "Suivant : Consentement relatif à l'IA",
    nextResumeUpload: "Suivant : Commencer la candidature",
    prorityEnd: "Statut de droit prioritaire",
    typeofEmployment: "Type d'emploi",
    employmentEndDate: "Date de fin d'emploi",
    priNumber: "CIDP",
    Institution: "Établissement",
    areaOfStudy: "Domaine d'études",
    graduationDate: "Date d'obtention du diplôme",
    lookingForITRole: "À la recherche d'un poste en informatique ?",
    other: "Autre",
    additionalInfoHeader: "Questions sur les renseignements supplémentaires",
    attachedResume: "curriculum vitæ joint",
    aiConsentHeader: "Assistance par intelligence artificielle (IA)",
    aiConsentSubHeader: "Veuillez confirmer si vous souhaitez que l’intelligence artificielle (IA) vous aide à rédiger votre demande.",
    aiConsentLabel: "À propos de l’aide de l’IA",
    aiConsentblab: "Nous offrons un outil d’IA facultatif qui peut vous aider à rédiger certaines parties de votre candidature (par exemple, en remplissant automatiquement certains champs à partir de votre CV). Cet outil est utilisé uniquement si vous choisissez d’y avoir recours.",
    aiConsentul1: "• L’outil d’IA n’est pas utilisé pour examiner, évaluer ou prendre des décisions concernant votre candidature.",
    aiConsentul2: "• Une fois votre candidature soumise, l’outil d’IA n’est plus utilisé à aucune étape du processus d’embauche.",
    aiConsentYes: "Oui, je souhaite bénéficier de l’aide de l’IA.",
    aiConsentNo: "Non, je souhaite remplir ma candidature sans l’aide de l’IA.",
    validSLEResults: "Résultats ELS valides",
    currentLevel: "Quel est votre niveau de classification actuel?",
    defenceTeamCareersSupport: "Soutien aux carrières de l'équipe de la Défense",
    reportAnIssue: "Signaler un problème",
    aboutUs: "À propos de nous",
    termsOfUseJobSeekers: "Conditions d'utilisation - Chercheurs d'emploi",
    termsOfUseEmployers: "Conditions d'utilisation - Employeurs",
    termsAndConditions: "Termes et conditions",
    privacy: "Confidentialité",
    defenceTeamCareers: "Bureau de gestion de la communauté TI de l'Équipe de la Défense",
    statusAIConsent: "Consentement à l’utilisation de l’intelligence artificielle (IA)",
    statusResumeUploaded: "Téléversement du CV",
    statusContactInformation: "Coordonnée",
    statusPriorities: "Droit de priorité",
    statusEmployment: "Statut d'emploi",
    statusLanguageInformation: "Informations linguistiques",
    statusSecurityEducation: "Sécurité et éducation",
    statusSkillsCompetencies: "Compétences et aptitudes",
    statusReview: "Révision",
    employmentDescription: "Le Service public fédéral comprend tous les ministères, organismes et sociétés d'État du gouvernement du Canada. Votre statut d'emploi actuel nous aide à comprendre votre admissibilité à différents types de postes.",
    PRIDescription: "Un CIDP est un numéro attribué afin d’associer un employé à ses dossiers personnels dans la fonction publique fédérale.",
    employmentDate: "Si vous occupez un poste pour une durée indéterminée, laissez ce champ vide.",
    required: "(obligatoire)",
    stepHeader: "Carrières de l'Équipe de la Défense",
    aboutUsDescParagraph1: "établissons des partenariats avec des intervenants du milieu de l’enseignement et de l’industrie",
    aboutUsDescParagraph2: "harmonise la dotation en TI avec les priorités ministérielles",
    contactUs: "Contactez-nous",
    contactUsDescription: "Vous avez des questions ou besoin d'aide avec votre candidature? Notre équipe est là pour vous aider. Veuillez nous contacter en utilisant les informations ci-dessous.",
    contactEmail: "Courriel",
    reportIssueDescription: "Si vous rencontrez un problème lors de la soumission de vos renseignements, veuillez communiquer avec nous.",
    supportDescription: "La section Soutien aux carrières fournit des conseils et des informations de contact pour les demandes liées aux RH, les processus de recrutement et les ressources d'emploi au sein de l'Équipe de la Défense.",
    reportIncluds: "Lorsque vous signalez un problème, veuillez inclure :",
    reportStep1: "- Une brève description du probleme",
    reportStep2: "- L'étape où le problème est survenu",
    reportStep3: "- Tout message d'erreur affiché (le cas échéant)",
    reportStep4: "- La date et l'heure auxquelles le problème est survenu",
    reportReason: "Ces renseignements nous aideront à vous répondre plus efficacement.",
    supportContactPrefix: "Veuillez nous contacter à",
    supportContactSuffix: "et un membre de notre équipe vous répondra dans les plus brefs délais.",
    confirmation: "Confirmation",
    pleaseIndicatePreference: "Veuillez indiquer votre préférence.",
    consentNo: "Je ne consens pas",
    maintenanceNoticeTitle: "Avis de maintenance programmée",
    maintenanceNoticeMessage: "Notre système est actuellement en maintenance du {startDate} au {endDate}.",
    maintenanceApology: "Nous nous excusons pour cet inconvénient et vous remercions de votre patience.",
    maintenanceStartDate: "Vendredi 21 novembre, 14h00 (HNE)",
    maintenanceEndDate: "Lundi 24 novembre, 8h00 (HNE)",
    dateModifiedLabel: "Date de modification :",
    yourProgress: "Votre progression",
    currentStep: "Étape actuelle",
    error: "Erreur",
    qualifiedFullyAssessedPoolLabel: "Faites-vous partie d’un bassin de candidats entièrement évalués et qualifiés?",
    qualifiedFullyAssessedPoolYes: "Oui",
    qualifiedFullyAssessedPoolNo: "Non",
    staffingProcessLabel: "Si oui, veuillez fournir le numéro du processus de sélection.",
    staffingProcessPlaceholder: "Veuillez saisir votre réponse ici",
    staffingProcess: "Processus de sélection",
    GroupFullyAssessedLabel: "Veuillez indiquer le groupe pour lequel vous avez fait l’objet d’une évaluation complète :",
    GroupFullyAssessedPlaceholder: "Sélectionnez le groupe pour lequel vous avez fait l’objet d’une évaluation complète",
    LevelFullyAssessedLabel: "Veuillez indiquer le niveau pour lequel vous avez fait l’objet d’une évaluation complète :",
    GroupFullyAssessed: "classification actuelle pour le bassin entièrement évalué",
    LevelFullyAssessed: "niveau de classification actuel pour le bassin entièrement évalué",
    areaofStudyEnd: "Spécialisation",
    postSecondaryInstitutionEnd: "Établissement d’enseignement postsecondaire",
    postSecondaryEducationLevelEnd: "Niveau d’études postsecondaires",
    graduationDateEnd: "Date d’obtention du diplôme",
    lookingForITRoleEnd: "À la recherche d’un poste en TI ?",
  },
};
